/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DecideRequest } from '../models/DecideRequest';
import type { MobileNotificationSchema } from '../models/MobileNotificationSchema';
import type { MobileNotificationStatus } from '../models/MobileNotificationStatus';
import type { PaginatedResponseMobileNotificationSchema } from '../models/PaginatedResponseMobileNotificationSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileNotificationsService {
    /**
     * Get the mobile user's notification history, newest first
     * Get the authenticated mobile user's notification history.
     * @param statuses
     * @param agentId
     * @param skip
     * @param limit
     * @param xMobileAuth
     * @returns PaginatedResponseMobileNotificationSchema Successful Response
     * @throws ApiError
     */
    public static getMobileUserNotifications(
        statuses?: (Array<MobileNotificationStatus> | null),
        agentId?: (string | null),
        skip?: number,
        limit: number = 100,
        xMobileAuth?: (string | null),
    ): CancelablePromise<PaginatedResponseMobileNotificationSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/notifications/',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            query: {
                'statuses': statuses,
                'agent_id': agentId,
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Approve or deny a pending notification
     * Record the mobile user's decision on a pending notification.
     * @param notificationId
     * @param requestBody
     * @param xMobileAuth
     * @returns MobileNotificationSchema Successful Response
     * @throws ApiError
     */
    public static decideMobileNotification(
        notificationId: string,
        requestBody: DecideRequest,
        xMobileAuth?: (string | null),
    ): CancelablePromise<MobileNotificationSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v1/notifications/{notification_id}/decide',
            path: {
                'notification_id': notificationId,
            },
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `notification_id is not a valid UUID`,
                404: `notification not found or not the caller's`,
                409: `notification already decided or expired`,
                422: `Validation Error`,
            },
        });
    }
}
